export default "__VITE_ASSET__D98uAsHk__";